import React from 'react';

function ViewControls({ searchMode, viewMode, viewModes, onViewModeChange }) {
  if (viewModes.length === 0) {
    return null;
  }

  if (searchMode !== 'developments') {
    return null;
  }

  const gridMode = viewModes.find((mode) => mode.value === 'grid');
  const mapMode = viewModes.find((mode) => mode.value === 'map');

  if (!gridMode || !mapMode) {
    return null;
  }

  return (
    <label className="inline-flex items-center gap-3 cursor-pointer flex-shrink-0">
      <span className="select-none text-sm font-medium text-black">
        <img src={gridMode.icon} alt="" className="size-4 md:hidden" />
        <span className="hidden md:block">{gridMode.label}</span>
      </span>

      <input
        type="checkbox"
        checked={viewMode === 'map'}
        onChange={() => onViewModeChange(viewMode === 'grid' ? 'map' : 'grid')}
        className="sr-only peer"
      />

      <div className="relative w-9 h-5 bg-[#4497F7] rounded-full transition-colors duration-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500 peer-focus:ring-offset-2">
        <div
          className={`absolute top-0.5 left-0.5 size-4 bg-white rounded-full shadow-sm transition-transform duration-200 ${
            viewMode === 'map' ? 'transform translate-x-4' : ''
          }`}
        />
      </div>

      <span className="select-none text-sm font-medium text-black">
        <img src={mapMode.icon} alt="" className="size-4 md:hidden" />
        <span className="hidden md:block">{mapMode.label}</span>
      </span>
    </label>
  );
}
export default ViewControls;
